function handleInputValidation() {
    const forms = document.querySelectorAll('form');

    forms.forEach(form => {
        const inputs = form.querySelectorAll('input, select, textarea'); // Include select and textarea fields
        const button = form.querySelector('button');

        const mappedInputs = Array.from(inputs).filter(input => input.classList.contains('validation'));

        // Disable button on page load if required fields are empty
        const areRequiredFieldsEmpty = Array.from(mappedInputs).some(
          (input) => input.required && input.value.trim() === ''
        )
        button.disabled = areRequiredFieldsEmpty;

        mappedInputs.forEach((input) => {
          input.addEventListener('input', () => {
            if (input.required) {
              const areAllFieldsValid = Array.from(mappedInputs).every(
                (input) => input.value.trim() !== ''
              )
              button.disabled = !areAllFieldsValid
              if (input.value.trim() == '') {
                input.classList.add('invalid')
              }
              else {
                input.classList.remove('invalid')
              }
            }
          })
        })
    });
}

window.addEventListener('load', handleInputValidation);

handleInputValidation();
